import { render, staticRenderFns } from "./SentenceLength.vue?vue&type=template&id=4e66aad8&"
import script from "./SentenceLength.vue?vue&type=script&lang=ts&"
export * from "./SentenceLength.vue?vue&type=script&lang=ts&"
import style0 from "./SentenceLength.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports